const NullQuestions = [
    {
        personType: "NATURALPERSON",
        uniqueIdentifier: null,
        addresses: [
            {
                street: "Jahawar nagar",
                city: "Mumbai",
                state: "Maharashtra",
                pincode: "400043"
            }
        ],
        communications: [
            {
                communicationType: "EMAIL",
                communicationId: "harshpiparwar@gmail.com",
                isPrefferedCommunication: true
            },
            {
                communicationType: "MOBILE",
                communicationId: 8076489924,
                isPrefferedCommunication: true
            }
        ],
        identificationDocuments: [],
        isPrimaryInsuredPerson: true,
        isPolicyHolder: true,
        isPayer: true,
        isInsuredPerson: true,
        isPrimaryPolicyHolder: true,
        nominee: {
            firstName: "Sila",
            middleName: null,
            lastName: "sharma",
            dateOfbirth: "1980-08-07",
            gender: "FEMALE",
            relationship: "SISTER"
        },
        firstName: null,
        middleName: null,
        lastName: "pip",
        dateOfbirth: "1998-07-08",
        profession: "BUSINESSMAN",
        gender: "MALE",
        relationship: "SELF",
        maritalStatus: "L",
        physicalCharacteristics: {
            height: "180",
            weight: "80"
        },
        coverages: [
            {
                coverType: "48717",
                sumInsuredAmount: "500000"
            },
            {
                coverType: "48718",
                sumInsuredAmount: "500000"
            }
        ],
        medical: {
            medicalQuestions: [
                {
                    questionCode: "RICOV",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false
                },
                {
                    questionCode: "RMPRE",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: [
                        {
                            questionCode: "RSPR1",
                            answerType: "TEXT_DESCRIPTION",
                            isApplicable: false,
                            detailAnswer: null
                        },
                        {
                            questionCode: "RSPR2",
                            answerType: "DATE",
                            isApplicable: false,
                            detailAnswer: null
                        },
                        {
                            questionCode: "RSPR3",
                            answerType: "TEXT_DESCRIPTION",
                            isApplicable: false,
                            detailAnswer: null
                        },
                        {
                            questionCode: "RSPR4",
                            answerType: "BOOLEAN",
                            isApplicable: false,
                            detailAnswer: false
                        }
                    ]
                },
                {
                  questionCode: "RPTHR",
                  answerType: "BOOLEAN",
                  isApplicable: false,
                  detailAnswer: false,
                  subQuestions: [
                      {
                          questionCode: "RSTH1",
                          answerType : "DOMAIN",
                          isApplicable: false,
                          detailAnswer: null
                      },
                      {
                          questionCode: "RSTH2",
                          answerType: "TEXT_DESCRIPTION",
                          isApplicable: false,
                          detailAnswer: null
                      },
                      {
                          questionCode: "RSTH3",
                          answerType: "DOMAIN",
                          isApplicable: false,
                          detailAnswer: null
                      },
                      {
                          questionCode: "RSTH4",
                          answerType: "BOOLEAN",
                          isApplicable: false,
                          detailAnswer: false
                      }
                  ]
              },
              {
                questionCode: "RPDBE",
                answerType: "BOOLEAN",
                isApplicable: false,
                detailAnswer: false,
                subQuestions: [
                    {
                        questionCode: "RSDB1",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB2",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB3",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB4",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB5",
                        answerType: "TEXT_DESCRIPTION",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB6",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: false,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB7",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: false,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB8",
                        answerType: "BOOLEAN",
                        isApplicable: false,
                        detailAnswer: false,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB9",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    },
                    {
                        questionCode: "RSDB10",
                        answerType: "DOMAIN",
                        isApplicable: false,
                        detailAnswer: null,
                        subQuestions: []
                    }
                ]
            },
            {
              questionCode: "RPAST",
              answerType: "BOOLEAN",
              isApplicable: false,
              detailAnswer: false,
              subQuestions: [
                  {
                      questionCode: "RSAS1",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: null,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS2",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: null,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS3",
                      answerType: "DOMAIN",
                      isApplicable: false,
                      detailAnswer: null,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS4",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: false,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS5",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: false,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS6",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: false,
                      subQuestions: []
                  },
                  {
                      questionCode: "RSAS7",
                      answerType: "BOOLEAN",
                      isApplicable: false,
                      detailAnswer: false,
                      subQuestions: []
                  }
              ]
            },
            {
            questionCode: "RPHPT",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSHP1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                },
                {
                    questionCode: "RSHP2",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP2A",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP3",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                },
                {
                    questionCode: "RSHP4",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: "HP4B",
                    subQuestions: []
                },
                {
                    questionCode: "RSHP5",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                },
                {
                    questionCode: "RSHP6",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                },
                {
                    questionCode: "RSHP7",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                },
                {
                    questionCode: "RSHP8",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPHLD",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSLD1",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                },
                {
                    questionCode: "RSLD2",
                    answerType: "BOOLEAN",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                },
                {
                    questionCode: "RSLD3",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPOGM",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSGM1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPDIG",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSDG1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: false,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPGYN",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSGN1",
                    answerType: "TEXT_DESCRIPTION",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPTBC",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSTB1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                }
            ]
            },
            {
            questionCode: "RPALC",
            answerType: "BOOLEAN",
            isApplicable: false,
            detailAnswer: false,
            subQuestions: [
                {
                    questionCode: "RSAL1",
                    answerType: "DOMAIN",
                    isApplicable: false,
                    detailAnswer: null,
                    subQuestions: []
                }
            ]
            }
            ]
        }
    }       
];

export default NullQuestions;